module.exports = __webpack_public_path__ + "static/media/phone_hand-02.23011fb0.png";